import ReactSelect from 'react-select';
import { useField } from 'formik';
import { customStyles } from '../inputFormik/select-input-formik';

const CustomSelect = ({ label, cols = '', labelClassName = '', ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div className={`${cols || ' '} flex flex-col`}>
      <label
        htmlFor={props.id || props.name}
        className={`max-lg:text-sm ${labelClassName}`}
      >
        {label} {props?.mandatory && <span className='text-red-600'>*</span>}
      </label>
      <ReactSelect
        {...field}
        {...props}
        onChange={(option) => {
          props?.onChange(option);
          field.onChange({
            target: {
              name: field.name,
              value: option.value,
            },
          });
        }}
        onBlur={() => field.onBlur(field.name)}
        value={
          props.options
            ? props.options.find((option) => option.value === field.value)
            : ''
        }
        className={`mt-1 ${meta.touched && meta.error ? 'border-red-500' : ''} py-0`}
        classNamePrefix='react-select'
        styles={customStyles}
      />
      {meta.touched && meta.error ? (
        <div className='text-sm text-red-500 max-sm:text-xs'>{meta.error}</div>
      ) : null}
    </div>
  );
};

export default CustomSelect;
